export default {
    path: "feedback",
    meta: { label: "Employee Feedback" },
    component: {
        render(c) {
            return c("router-view");
        },
    },
    children: [
        {
            path: "",
            meta: {
                requiresAuth: true,
            },
            component: () => import("@/views/feedback/customerFeedback.vue"),
        },
        {
            path: "view/:id/:feedbackId",
            name: "View Employee Feedback",
            meta: {
                requiresAuth: true,
            },
            component: () => import("@/views/feedback/viewFeedback.vue"),
        },
    ],
};